import React from 'react'
import AllClinics from './AllClinics'
import { useNavigate } from "react-router-dom";
import { useState, useMemo } from "react";

function Clinics() {
  // const [viewType, setViewType] = useState("List");
  const navigate = useNavigate();

  return (
    <>
      <main style={{ width: "100%", height: "100%" }}>
        <div className="row">
          <div className="col-12 mb-4 d-flex justify-content-between">

            <div className="d-flex">
              <h4 className='m-0 p-3'>
                Clinics
              </h4>
            </div>

            <div className='d-flex align-items-center justify-content-end gap-3'>
              <button className='gradient-button' onClick={() => navigate("/Registration")}>+ Add Clinic</button>
              <div className='d-flex align-items-center gap-3'>
                <div className="position-relative div-okij8ijj">
                  <input type="text" className="form-control div-TzEiOdMeYO" placeholder='Search here' style={{ padding: "0px 1.7rem 0px .5rem", borderRadius: ".3rem" }} />
                  <div className="position-absolute" style={{ top: "10px", right: '8px' }}>
                    <button style={{ background: "none", border: 'none', }}><i class="fa-solid fa-magnifying-glass"></i></button>
                  </div>
                </div>

                {/* <button
                  style={{ background: "none" }}
                  className="border-0"
                  type="button"
                  onClick={() => setViewType("List")}
                >
                  <i class="fa-solid fa-rectangle-list"></i>
                </button> */}

                {/* <button
                  style={{ background: "none" }}
                  className="border-0"
                  type="button"
                  onClick={() => setViewType("Grid")}
                >
                  <i class="fa-solid fa-border-all"></i>
                </button> */}

              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-12">
            <AllClinics />
          </div>
        </div>


        {/* {viewType === "Grid" && (
          <div className="row">
            < />
          </div>
        )} */}


      </main>

    </>
  )
}

export default Clinics